import { useReportFilenameExampleQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { ReportFilename } from '../../../ReportFilenamesContext/types'
import { Spin } from 'antd'
import { useRefetchWithParent } from '../../../../../hooks/useRefetchWithParent'
import { useReportFilenamesContext } from '../../../ReportFilenamesContext'
import { useProjectContext } from 'context/ProjectContext'

const Example: React.FC<ReportFilename> = ({ id: reportId }) => {
  const { projectId } = useProjectContext()
  const { loading: parentLoading } = useReportFilenamesContext()
  const { data, loading, refetch } = useReportFilenameExampleQuery({
    ...DefaultQueryHookOptions,
    variables: { input: { reportId, projectId } },
  })
  useRefetchWithParent({ refetch, parentLoading })
  return (
    <Spin spinning={loading ?? false} size="small">
      {data?.reportFilenameExample}
    </Spin>
  )
}

export default Example
